import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import './privacy-policy.css'; 

export default function PrivacyPolicy() {


    useEffect(() => {
        window.scrollTo(0, 0); 
      }, []);
    

  return (
    <>
      <Navbar />
      <section className="PrivacyPolicy">
        <h1>Privacy Policy</h1>
        <p>Welcome to Sri Hari Home Care! Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you use our services.</p>

        <h2>1. Information We Collect</h2>
        <p>We may collect personal information from you, including your name, email address, phone number, and address when you schedule a service or contact us.</p>

        <h2>2. How We Use Your Information</h2>
        <p>Your information helps us provide, maintain, and improve our services. We may use your information to:</p>
        <ul>
          <li>Process your service requests</li>
          <li>Communicate with you regarding your service</li>
          <li>Improve our customer service</li>
          <li>Send you promotional materials and updates (if you opt-in)</li>
        </ul>

        <h2>3. Sharing Your Information</h2>
        <p>We do not sell or rent your personal information to third parties. We may share your information with trusted partners to help us provide our services, but only as necessary and with appropriate safeguards in place.</p>

        <h2>4. Data Security</h2>
        <p>We implement a variety of security measures to maintain the safety of your personal information. However, no method of transmission over the internet or method of electronic storage is 100% secure.</p>

        <h2>5. Your Rights</h2>
        <p>You have the right to access, correct, or delete your personal information. If you wish to exercise any of these rights, please contact us using the information below.</p>

        <h2>6. Cookies</h2>
        <p>Our website may use cookies to enhance your experience. You can choose to accept or decline cookies. Declining cookies may prevent you from taking full advantage of the website.</p>

        <h2>7. Changes to This Privacy Policy</h2>
        <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page, and we encourage you to review it periodically.</p>

        <h2>8. Contact Us</h2>
        <p>If you have any questions or concerns about this Privacy Policy, please contact us at <a href="mailto:contact@harihomecare.com">contact@harihomecare.com</a>.</p>
      </section>
      <Footer />
    </>
  );
}
